import React from 'react';
import { ToolbarProps } from './types';
import { ArcStack } from '@src/core/ui';
import { FindMe, Layers, Ruller, Weather } from './components';

const Toolbar: React.FC<ToolbarProps> = () => {
  return (
    <React.Fragment>
      <ArcStack top={10} right={5} zIndex={1100} position='absolute' sx={{ overflow: 'visible' }}>
        <Weather />
      </ArcStack>

      <ArcStack top={'40%'} right={5} zIndex={1100} position='absolute' sx={{ overflow: 'visible' }}>
        <ArcStack spacing={1} direction='column' alignItems='end'>
          <Layers />
          <Ruller />
          <FindMe />
        </ArcStack>
      </ArcStack>
    </React.Fragment>
  );
};

export default Toolbar;